import { decodeUri } from './decode'
import applyHttpsImage from 'lib/apply-https-img'
/**
 * 是否支持webp格式
 * @type {boolean}
 */
const canUseWebp = (() => {
  if (typeof document === 'undefined') {
    return false
  }
  const elem = document.createElement('canvas')
  if (elem && elem.getContext && elem.getContext('2d')) {
    return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0
  }
  return false
})()

const cdnDomain = 'p3.dcarimg.com'

function getSize({
  width,
  autoPixelRatio,
}: {
  width?: number
  autoPixelRatio?: boolean
}) {
  if (!width) {
    return 'noop'
  }
  // 服务器端默认2倍大小，客户端根据实际的window?.devicePixelRatio
  // if (autoPixelRatio) {
  //   let pixelRatio = 2
  //   if (typeof window !== 'undefined' && window?.devicePixelRatio) {
  //     pixelRatio = window?.devicePixelRatio
  //   }
  //   return `${~~Math.abs(width * pixelRatio)}x0`
  // }
  // 全部取2倍图
  return `${~~Math.abs(width * 2)}x0`
}

function getExt(src: string): string {
  const append = src.match(/([^/]+?)(?:[#?].+)?$/)?.[1] || ''

  // 优先取uri里面的格式 再取 切图参数里面的 格式
  // https://xxx.dcd.com/tos-xx-xx/3243.32131.jpg~200x200.png -> jpg
  // https://xxx.dcd.com/tos-xx-xx/3243.32131~200x200.png -> png
  const [uri, param] = append.split('~')
  const extRegx = /.+\.([a-z]{2,5})$/i
  const matches = uri.match(extRegx) || param?.match(extRegx)

  // 动图保留源格式
  if (['awebp', 'gif'].includes(matches?.[1]!)) {
    return matches![1]
  }

  if (canUseWebp) {
    return 'webp'
  }

  if (!matches || !matches[1]) {
    return 'png'
  }

  if (!canUseWebp && matches[1] === 'webp') {
    return 'png'
  }

  return matches[1]
}

export type GenImgAttrsData = {
  src: string
  unoptimized?: boolean
  width?: number
  // height?: number
  autoPixelRatio?: boolean
  // 裁剪方式，ImageX服务文档： https://bytedance.feishu.cn/docs/doccn7ehHqqE7XOap2Dsfobj64h#G7yDN3
  // 默认定宽缩放
  cutType?:
    | 'c1' // 居上裁剪
    | 'c5' // 居中裁剪
    | 'cs' // 人脸识别，开销更大 谨用
}

export function getOptimizedImage(params: GenImgAttrsData): string {
  const {
    src,
    unoptimized,
    width,
    // height,
    // autoPixelRatio,
    cutType,
  } = params
  if (typeof src !== 'string') {
    return ''
  }
  const isUrl = /^(((https?:)?\/)?\/)/.test(src)
  if (unoptimized) {
    return isUrl ? applyHttpsImage(src) : `//${cdnDomain}/obj/${src}`
  }

  // 获取uri，如果不是tos地址，就不匹配
  const uri = isUrl ? decodeUri(src) : src

  if (!uri) {
    return applyHttpsImage(src)
  }

  const size = getSize({ width })
  const ext = getExt(src)
  return `//${cdnDomain}/img/${uri}~${
    cutType ? `${cutType}_` : ''
  }${size}.${ext}`
}
